export const ALLOWED_PAYROLL_ROLES = ["admin", "miniadmin", "hr", "vacation-hr"];

export const resolveEffectiveEmployeeId = (propEmployeeId, selectedEmployeeId, storedEmployeeId) =>
  propEmployeeId || selectedEmployeeId || storedEmployeeId || null;

export const resolveEffectiveCompanyId = (propCompanyId, storedCompanyId) =>
  propCompanyId || storedCompanyId || null;

export const canManagePayroll = (rolesSet, userRole) => {
  const normalizedRole = userRole ? String(userRole).toLowerCase() : "";
  if (rolesSet && typeof rolesSet.has === "function") {
    if (ALLOWED_PAYROLL_ROLES.some((role) => rolesSet.has(role))) {
      return true;
    }
  }
  return ALLOWED_PAYROLL_ROLES.includes(normalizedRole);
};

export const shouldShowEmployeeSelector = ({
  effectiveEmployeeId,
  allowCompanyFallback,
  canManagePayments,
  effectiveCompanyId,
}) =>
  !effectiveEmployeeId &&
  !allowCompanyFallback &&
  canManagePayments &&
  Boolean(effectiveCompanyId);

export const buildEmployeeOptions = (employees = []) =>
  employees.map((emp) => {
    const id = Number(emp.id);
    const name = `${emp.first_name || ""} ${emp.last_name || ""}`.trim() || `#${id}`;
    return {
      id,
      title: name,
      value: id,
      subtitle: emp.position || emp.email || "",
    };
  });
